import { render } from "./PipDetails.vue?vue&type=template&id=074e2c8c&scoped=true"
import script from "./PipDetails.vue?vue&type=script&lang=js"
export * from "./PipDetails.vue?vue&type=script&lang=js"

import "./PipDetails.vue?vue&type=style&index=0&id=074e2c8c&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074e2c8c"]])

export default __exports__